@if (!isHorseRace) {
    <span>{{ title }}</span
    ><span class="winmarket-title">{{ distance }}</span>
} @else {
    @if (title) {
        <span>{{ title }}</span>
    }
    @if (distance) {
        <span class="winmarket-title">, {{ distance }}</span>
    }
}
